import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/logistic/cdf';
import __var_2__ from '@stdlib/stats/base/dists/logistic/ctor';
import __var_3__ from '@stdlib/stats/base/dists/logistic/entropy';
import __var_4__ from '@stdlib/stats/base/dists/logistic/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/logistic/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/logistic/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/logistic/mean';
import __var_8__ from '@stdlib/stats/base/dists/logistic/median';
import __var_9__ from '@stdlib/stats/base/dists/logistic/mgf';
import __var_10__ from '@stdlib/stats/base/dists/logistic/mode';
import __var_11__ from '@stdlib/stats/base/dists/logistic/pdf';
import __var_12__ from '@stdlib/stats/base/dists/logistic/quantile';
import __var_13__ from '@stdlib/stats/base/dists/logistic/skewness';
import __var_14__ from '@stdlib/stats/base/dists/logistic/stdev';
import __var_15__ from '@stdlib/stats/base/dists/logistic/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace logistic
*/
var logistic = {};

/**
* @name cdf
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/cdf}
*/
setReadOnly( logistic, 'cdf', __var_1__);

/**
* @name Logistic
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/ctor}
*/
setReadOnly( logistic, 'Logistic', __var_2__);

/**
* @name entropy
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/entropy}
*/
setReadOnly( logistic, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/kurtosis}
*/
setReadOnly( logistic, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/logcdf}
*/
setReadOnly( logistic, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/logpdf}
*/
setReadOnly( logistic, 'logpdf', __var_6__);

/**
* @name mean
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/mean}
*/
setReadOnly( logistic, 'mean', __var_7__);

/**
* @name median
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/median}
*/
setReadOnly( logistic, 'median', __var_8__);

/**
* @name mgf
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/mgf}
*/
setReadOnly( logistic, 'mgf', __var_9__);

/**
* @name mode
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/mode}
*/
setReadOnly( logistic, 'mode', __var_10__);

/**
* @name pdf
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/pdf}
*/
setReadOnly( logistic, 'pdf', __var_11__);

/**
* @name quantile
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/quantile}
*/
setReadOnly( logistic, 'quantile', __var_12__);

/**
* @name skewness
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/skewness}
*/
setReadOnly( logistic, 'skewness', __var_13__);

/**
* @name stdev
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/stdev}
*/
setReadOnly( logistic, 'stdev', __var_14__);

/**
* @name variance
* @memberof logistic
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/logistic/variance}
*/
setReadOnly( logistic, 'variance', __var_15__);


// EXPORTS //
export default logistic;

export { __var_1__ as cdf, __var_2__ as Logistic, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pdf, __var_12__ as quantile, __var_13__ as skewness, __var_14__ as stdev, __var_15__ as variance};